import React from 'react';

const ExpressContext = React.createContext({});
export const ExpressProvider = ExpressContext.Provider;

export default ExpressContext;
